module.exports = __webpack_public_path__ + "e0f56bdfa66c00a7217fdc20d00bb499.svg";